// shared/src/schemas/basket.ts
// In-flight chain-stage payload schema (not DDL-backed).
// Validates A-stage portfolio-aggregation input across N tickers.
// A2 drift-detector SKIPS this schema (no corresponding D1 table; this is
// the JSON-payload shape stored in `brief_payloads.payload` when kind='basket').
//
// Full shape locks at Phase 4 Step 16 per Plan §4.5.4a `BasketInput` interface.

import { z } from 'zod';
import { TickerSymbolSchema } from './ticker.js';

export const BasketSchema = z.object({
  tickers: z.array(TickerSymbolSchema).min(1),
  // Additional fields lock at Step 16 (A-stage input contract).
});

export type Basket = z.infer<typeof BasketSchema>;
